import ResourceHttp from '@/services/http/resources/frota/marcaHttp';
import { toastResponseError } from '@/services/util/alertService';

const dadosModulo = {
  namespaced: true,
  state: {
    loading: false,
    list: [],
    data: {},
    paginate: {
      page: null,
      totalPages: null,
      itemsPerPage: null,
      total: null,
    },
    dataIndex: -1,
    dialogForm: false,
  },
  mutations: {
    CLEAR_ALL(state) {
      state.list = [];
    },
    CLEAR(state) {
      state.data = {};
    },
    LOADING(state, status) {
      state.loading = status;
    },
    PAGINATION(state, meta) {
      state.paginate.page = meta.current_page;
      state.paginate.totalPages = meta.last_page;
      state.paginate.itemsPerPage = meta.per_page;
      state.paginate.total = meta.total;
    },
    ADD_DATA(state, data) {
      state.data = data;
    },
    ADD_IN_LIST(state, data) {
      state.list.push(data);
    },
    ADD_ALL(state, list) {
      state.list = list;
    },
    UPDATE_DATA(state, param) {
      const index = state.list.map((x) => x.id).indexOf(param.id);
      Object.assign(state.list[index], param);
    },
    EXCLUDE_DATA(state, index) {
      state.list.splice(index, 1);
    },
    SET_DATA_INDEX(state, dataIndex) {
      state.dataIndex = dataIndex;
    },
    TOGGLE_FORM(state) {
      state.dialogForm = !state.dialogForm;
    },
  },
  actions: {
    getAll({ commit }, param) {
      commit('LOADING', true);
      return new Promise((resolve, reject) => {
        ResourceHttp.all(param)
          .then((response) => {
            commit('ADD_ALL', response.data.data);
            commit('PAGINATION', response.data.meta);
            resolve(response);
          })
          .catch((error) => {
            toastResponseError(error);
            reject(error);
          })
          .finally(() => {
            commit('LOADING', false);
          });
      });
    },
    find({ commit }, param) {
      return new Promise((resolve, reject) => {
        ResourceHttp.find(param.id)
          .then((response) => {
            commit('ADD_DATA', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            toastResponseError(error);
            reject(error);
          });
      });
    },
    store({ commit, dispatch, state }, param) {
      return new Promise((resolve, reject) => {
        ResourceHttp.store(param)
          .then((response) => {
            dispatch('toggleForm');
            if (state.list.length === 0) {
              dispatch('getAll', response.data.data.rota_id);
            } else {
              commit('ADD_IN_LIST', response.data.data);
            }
            resolve(response);
          }).catch((error) => {
            reject(error);
          });
      });
    },
    edit({ commit, dispatch, state }, param) {
      const index = state.list.indexOf(param);
      return new Promise((resolve, reject) => {
        ResourceHttp.find(param.id)
          .then((response) => {
            commit('ADD_DATA', response.data.data);
            commit('SET_DATA_INDEX', index);
            dispatch('toggleForm');
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    update({ commit, dispatch }, param) {
      return new Promise((resolve, reject) => {
        ResourceHttp.update(param, param.id)
          .then((response) => {
            dispatch('toggleForm');
            commit('UPDATE_DATA', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    destroy({ commit, state }, param) {
      const index = state.list.indexOf(param);
      return new Promise((resolve, reject) => {
        ResourceHttp.destroy(param.id)
          .then((response) => {
            commit('EXCLUDE_DATA', index);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getToPage({ commit }, page) {
      commit('LOADING', true);
      return new Promise((resolve, reject) => {
        ResourceHttp.page(page)
          .then((response) => {
            commit('ADD_ALL', response.data.data);
            commit('PAGINATION', response.data.meta);
            resolve(response);
          })
          .catch((error) => {
            toastResponseError(error);
            reject(error);
          })
          .then(() => {
            commit('LOADING', false);
          });
      });
    },
    getPageSort({ commit }, parans) {
      commit('LOADING', true);
      return new Promise((resolve, reject) => {
        ResourceHttp.pageSort(parans)
          .then((response) => {
            commit('ADD_ALL', response.data.data);
            commit('PAGINATION', response.data.meta);
            resolve(response);
          })
          .catch((error) => {
            toastResponseError(error);
            reject(error);
          })
          .then(() => {
            commit('LOADING', false);
          });
      });
    },
    setDataIndex(context, dataIndex) {
      context.commit('SET_DATA_INDEX', dataIndex);
    },
    toggleForm({ commit }) {
      commit('TOGGLE_FORM');
    },
    clearData({ commit }) {
      commit('CLEAR');
    },
    reset({ commit }) {
      commit('CLEAR_ALL');
      commit('CLEAR');
      commit('LOADING', false);
      commit('SET_DATA_INDEX', -1);
    },
  },
};

export default dadosModulo;
